import { render, staticRenderFns } from "./MarkerRecords.vue?vue&type=template&id=88ac6eda"
import script from "./MarkerRecords.vue?vue&type=script&lang=js"
export * from "./MarkerRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports